import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css/animate.min.css";
import "./custom.css";
import "./responsive.css";
import Router from './router/NavRouter';
import SEO from "./helper/SEO";
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import React, { useEffect, useRef, useState } from 'react';
import { BaseUrl } from './helper/BaseUrl'; 

const hasSeoData = (seo) => (
  seo &&
  typeof seo === 'object' &&
  Object.values(seo).some((value) => {
    if (value === null || value === undefined) return false;
    return String(value).trim() !== '';
  })
);

function App({ initialData, initialSeo, initialSchema }) {
  const [seoData, setSeoData] = useState(() => (hasSeoData(initialSeo) ? initialSeo : null));
  const [schemaData, setSchemaData] = useState(() => (hasSeoData(initialSchema) ? initialSchema : null));
  const location = useLocation();
  const skipInitialSeoFetch = useRef(hasSeoData(initialSeo));

  useEffect(() => {
    if (skipInitialSeoFetch.current) {
      skipInitialSeoFetch.current = false;
      return undefined;
    }

    const controller = new AbortController();

    const fetchSeo = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/seo-by-url${location.pathname}`, {
          signal: controller.signal,
        });
        const result = await response.json();

        if (!response.ok || result.error || result.seo === false) {
          throw new Error(result.message || 'Unable to fetch SEO data.');
        }

        if (hasSeoData(result.seo)) {
          setSeoData(result.seo);
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('SEO fetch error:', error.message);
        }
      }
    };

    fetchSeo();
    return () => controller.abort();
  }, [location.pathname]);

  useEffect(() => {
    if (hasSeoData(schemaData)) {
      return undefined;
    }

    const controller = new AbortController();

    const fetchSchema = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/global-seo`, {
          signal: controller.signal,
        });
        const result = await response.json();

        if (!response.ok || result.error) {
          throw new Error(result.message || 'Unable to fetch Global SEO data.');
        }

        if (hasSeoData(result.schema)) {
          setSchemaData(result.schema);
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Global SEO fetch error:', error.message);
        }
      }
    };

    fetchSchema();
    return () => controller.abort();
  }, [schemaData]);

  //-------------- 

  // List of paths where "color-theme" should be added
  const colorThemePaths = ['/', '/contact', '/thankyou', '/404', '/sector-d', ];

  // Check if current path matches any from the list
  const isColorThemePage = colorThemePaths.includes(location.pathname);


  // Source Url
  useEffect(() => {
    if (typeof window !== "undefined") {
      const existingSource = sessionStorage.getItem("first_landing_url");
      if (!existingSource) {
        const landingUrl = window.location.href;
        sessionStorage.setItem("first_landing_url", landingUrl);
      }
    }
  }, []);


  const NormalizeTrailingSlash = () => {
  useEffect(() => {
      if (location.pathname !== '/' && location.pathname.endsWith('/')) {
        window.history.replaceState(
          null,
          '',
          location.pathname.slice(0, -1) + location.search + location.hash
        );
      }
    }, []);

    return null;
  };

  return (
    // <div className={`App ${isColorThemePage ? 'color-theme' : ''}`}>
    //   <ToastContainer/>
    //   <Router />
    //   <NormalizeTrailingSlash/>
    // </div>

 
    <div className={`App ${isColorThemePage ? 'color-theme' : ''}`}>
      <NormalizeTrailingSlash />
      <SEO seoData={seoData} schemaData={schemaData} />
      <Router initialData={initialData}/>
      <ToastContainer />
    </div>
  ); 
}

export default App;
